import React from 'react';
import dayjs from 'dayjs';
import MaskedInput from 'react-text-mask';
import { DATE_FORMAT } from '@utils/dates/dateMethods';
import { DATE_MASK } from '@utils/validators/regex';

interface CustomDateInputProps {
    value: any;
    id: string;
    minDate?: Date | string | null;
    maxDate?: Date | string | null;
    disabled?: boolean;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onDateError?: (value: string) => void;
    onResetDateError?: () => void;
    isRequired?: boolean;
}

const DatePickerInputMask: React.FC<CustomDateInputProps> = ({
    value,
    id,
    disabled,
    placeholder = 'mm/dd/yyyy',
    onChange,
    onBlur,
    minDate,
    maxDate,
    onDateError,
    onResetDateError,
    isRequired,
}) => {
    const getIsMaskLength = (value: string) => {
        return value.replace(/_/g, '').length === DATE_MASK.length;
    };

    const _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value: dateValue } = e.target;
        const date = dayjs(dateValue, DATE_FORMAT, true);

        if (date.isValid()) {
            onResetDateError?.();

            if (date.year() < 1900) {
                onDateError?.('DATE_BEFORE_1900_ERROR');
            }

            if (maxDate && date.isAfter(maxDate)) {
                const maxDated = dayjs(maxDate).format(DATE_FORMAT);
                e.target.value = maxDated;
            } else if (minDate && date.isBefore(minDate)) {
                const minDated = dayjs(minDate).format(DATE_FORMAT);
                e.target.value = minDated;
            }
        } else {
            const isInternalValueMaskLength = getIsMaskLength(dateValue);
            const isExternalValueMaskLength = getIsMaskLength(value);

            if (isInternalValueMaskLength || isExternalValueMaskLength) {
                onDateError?.(dateValue);
            }
        }

        onChange?.(e);
    };
    return (
        <div style={{ position: 'relative' }}>
            <MaskedInput
                mask={DATE_MASK}
                placeholder={placeholder}
                value={value}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                    e.target.value = value;
                    onBlur?.(e);
                }}
                id={id}
                data-testid={id}
                disabled={disabled}
                autoComplete="off"
                onChange={_onChange}
                aria-required={isRequired || undefined}
            />
        </div>
    );
};

export default DatePickerInputMask;
